import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getCmsPageRequest, getPageBySlugAndLanguage } from '../../CmsActions.js';

class PageContent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
		};
	}

	componentDidMount() {
		if(!this.props.page) {
			this.setContent();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.slug !== this.props.slug || (prevProps.locale !== this.props.locale && !this.props.page)) {
			this.setContent();
		}
	}

	setContent() {
		this.setState({
			isLoading: true,
		});
		return this.props.dispatch(getCmsPageRequest(this.props.slug, this.props.locale)).then(result => {
			if(result) {
				this.setState({
					isLoading: false,
				});
			} else {
				this.setState({
					isLoading: false,
				});
			}
		});
	}

	render() {
		return (
			<div className="htms-text-wrapper">
				{!this.state.isLoading && this.props.page ? <div dangerouslySetInnerHTML={{ __html: this.props.page.content }} /> : <div className="text-center"><FontAwesomeIcon icon="spinner" spin size="2x" /></div>}
			</div>
		);
	}
}

function mapStateToProps(store, props) {
	const { locale } = store.intl;
	return {
		locale,
		page: getPageBySlugAndLanguage(store, props.slug, locale),
	};
}

PageContent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	locale: PropTypes.string.isRequired,
	page: PropTypes.object,
	slug: PropTypes.string,
};

export default connect(mapStateToProps)(PageContent);
